import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { normal as normalFontWeight } from "./fontWeight.js";
import { normal as normalFontStyle } from "./fontStyle.js";
import { normal as normalTextDecoration } from "./textDecoration.js";
import { serializeCloudinaryCharacters } from "../internal/utils/serializeCloudinaryCharacters.js";
import { QualifierModel } from "../internal/models/QualifierModel.js";
import { solid } from "./textStroke.js";
import { isISolidStrokeModel } from "../internal/models/IStrokeModel.js";
/**
 * @summary qualifier
 * @description Specifies how to style your layered text, controls the font, font size, line spacing and more.
 * </br><b>Learn more</b>: {@link https://cloudinary.com/documentation/image_transformations#adding_text_overlays|Adding text overlays to images}
 * </br><b>Learn more</b>: {@link https://cloudinary.com/documentation/video_manipulation_and_delivery#adding_text_captions|Adding text overlays to videos}
 * @see {@link Actions.Overlay| The overlay action}
 * @see {@link Actions.Underlay| The underlay action}
 * @memberOf Qualifiers
 */

var TextStyle = /*#__PURE__*/function (_QualifierModel) {
  _inherits(TextStyle, _QualifierModel);

  var _super = _createSuper(TextStyle);

  /**
   * @param {string} fontFamily The font family
   * @param {number | string} fontSize The font size
   */
  function TextStyle(fontFamily, fontSize) {
    var _this;

    _classCallCheck(this, TextStyle);

    _this = _super.call(this);

    if (!fontFamily || !fontSize) {
      throw "You must provide a fontFamily and fontSize to a TextStyle";
    }

    _this._qualifierModel.fontFamily = fontFamily;
    _this._qualifierModel.fontSize = fontSize;
    return _this;
  }
  /**
   * @param {number} spacing The spacing between multiple lines in pixels.
   */


  _createClass(TextStyle, [{
    key: "lineSpacing",
    value: function lineSpacing(spacing) {
      this._qualifierModel.lineSpacing = spacing;
      return this;
    }
    /**
     * @param spacing The spacing between the letters, in pixels.
     */

  }, {
    key: "letterSpacing",
    value: function letterSpacing(spacing) {
      this._qualifierModel.letterSpacing = spacing;
      return this;
    }
    /**
     * The antialias setting to apply to the text. When this parameter is not specified, the default antialiasing for the subsystem and target device are applied.
     * @param {FontAntialiasType|string} antiAlias
     */

  }, {
    key: "fontAntialias",
    value: function fontAntialias(antiAlias) {
      this._qualifierModel.fontAntialias = antiAlias;
      return this;
    }
    /**
     * The name of any universally available font or a custom font, specified as the public ID of a raw, authenticated font in your account.
     * For details on custom fonts, see {@link https://cloudinary.com/documentation/image_transformations#using_custom_fonts_for_text_overlays|Using custom fonts for text overlays}.
     * @param {string} fontFamilyName
     */

  }, {
    key: "fontFamily",
    value: function fontFamily(fontFamilyName) {
      this._qualifierModel.fontFamily = fontFamilyName;
      return this;
    }
    /**
     * @param {number} fontSize The font size
     */

  }, {
    key: "fontSize",
    value: function fontSize(_fontSize) {
      this._qualifierModel.fontSize = _fontSize;
      return this;
    }
    /**
     * @param {FontWeightType|string} fontWeight The font weight
     */

  }, {
    key: "fontWeight",
    value: function fontWeight(_fontWeight) {
      this._qualifierModel.fontWeight = _fontWeight;
      return this;
    }
    /**
     *
     * @param {string} fontStyle The font style.
     */

  }, {
    key: "fontStyle",
    value: function fontStyle(_fontStyle) {
      this._qualifierModel.fontStyle = _fontStyle;
      return this;
    }
    /**
     * @param {string} fontHinting The outline hinting style to apply to the text. When this parameter is not specified, the default hint style for the font and target device are applied.
     */

  }, {
    key: "fontHinting",
    value: function fontHinting(_fontHinting) {
      this._qualifierModel.fontHinting = _fontHinting;
      return this;
    }
    /**
     *
     * @param {TextDecorationType|string} textDecoration The font decoration type.
     */

  }, {
    key: "textDecoration",
    value: function textDecoration(_textDecoration) {
      this._qualifierModel.textDecoration = _textDecoration;
      return this;
    }
    /**
     * @param {TextAlignmentType|string} textAlignment The text alignment
     */

  }, {
    key: "textAlignment",
    value: function textAlignment(_textAlignment) {
      this._qualifierModel.textAlignment = _textAlignment;
      return this;
    }
    /**
     * @description Whether to include an outline stroke. Set the color and weight of the stroke
     */

  }, {
    key: "stroke",
    value: function stroke(textStroke) {
      if (textStroke) {
        var strokeStyle = textStroke.split('_');
        this._qualifierModel.stroke = {
          width: +strokeStyle[1].replace('px', ''),
          color: strokeStyle[strokeStyle.length - 1]
        };
      } else {
        this._qualifierModel.stroke = true;
      }

      return this;
    }
  }, {
    key: "toString",
    value: function toString() {
      var stroke = this._qualifierModel.stroke;
      var strokeStr = '';

      if (stroke) {
        strokeStr = isISolidStrokeModel(stroke) ? "stroke_".concat(solid(stroke.width, stroke.color)) : 'stroke';
      }

      return ["".concat(serializeCloudinaryCharacters(this._qualifierModel.fontFamily), "_").concat(this._qualifierModel.fontSize), this._qualifierModel.fontWeight !== normalFontWeight() && this._qualifierModel.fontWeight, this._qualifierModel.fontStyle !== normalFontStyle() && this._qualifierModel.fontStyle, this._qualifierModel.textDecoration !== normalTextDecoration() && this._qualifierModel.textDecoration, this._qualifierModel.textAlignment, strokeStr, this._qualifierModel.letterSpacing && "letter_spacing_".concat(this._qualifierModel.letterSpacing), this._qualifierModel.lineSpacing && "line_spacing_".concat(this._qualifierModel.lineSpacing), this._qualifierModel.fontAntialias && "antialias_".concat(this._qualifierModel.fontAntialias), this._qualifierModel.fontHinting && "hinting_".concat(this._qualifierModel.fontHinting)].filter(function (a) {
        return a;
      }).join('_');
    }
  }]);

  return TextStyle;
}(QualifierModel);

export { TextStyle };